// extracted by mini-css-extract-plugin
export default {"main":"noSelectedChat_main__p8q0i"};